/**
 * Workflow module translations - English
 * Includes: todo, done, initiated, definition
 */
export default {
  workflow: {
    // Todo tasks
    todo: {
      title: 'Todo Tasks',
      keyword: 'Keyword',
      keywordPlaceholder: 'Business title / task name',
      taskName: 'Task Name',
      businessTitle: 'Business Title',
      businessType: 'Business Type',
      taskStatus: 'Status',
      receiveTime: 'Received',
      approval: 'Approve',
      transfer: 'Transfer',
      // Business type mapping (now driven by wf_business_type dict table, kept as fallback)
      businessTypeContract: 'Contract',
      businessTypeContractNew: 'New Contract',
      businessTypeContractRenewal: 'Contract Renewal',
      businessTypeContractAmendment: 'Contract Amendment',
      businessTypeMerchant: 'Merchant',
      businessTypeOther: 'Other',
      // Status mapping
      statusPending: 'Pending',
      statusClaimed: 'Claimed',
    },
    // Done tasks
    done: {
      title: 'Completed',
      keyword: 'Keyword',
      keywordPlaceholder: 'Business title / task name',
      taskName: 'Task Name',
      businessTitle: 'Business Title',
      businessType: 'Business Type',
      action: 'Action',
      comment: 'Comment',
      completeTime: 'Completed',
      // Action mapping
      actionApprove: 'Approved',
      actionReject: 'Rejected',
      actionTransfer: 'Transferred',
      actionDelegate: 'Delegated',
      // Business type mapping (now driven by wf_business_type dict table, kept as fallback)
      businessTypeContract: 'Contract',
      businessTypeContractNew: 'New Contract',
      businessTypeContractRenewal: 'Contract Renewal',
      businessTypeContractAmendment: 'Contract Amendment',
      businessTypeMerchant: 'Merchant',
      businessTypeOther: 'Other',
    },
    // Initiated
    initiated: {
      title: 'My Initiated',
      processStatus: 'Process Status',
      processStatusPlaceholder: 'Select status',
      keyword: 'Keyword',
      keywordPlaceholder: 'Business title / process name',
      processName: 'Process Name',
      businessTitle: 'Business Title',
      currentNode: 'Current Node',
      instanceStatus: 'Process Status',
      startTime: 'Started',
      endTime: 'Ended',
      progress: 'Progress',
      withdraw: 'Withdraw',
      withdrawConfirmTitle: 'Withdraw Confirmation',
      withdrawReasonPlaceholder: 'Enter reason (optional)',
      withdrawSuccess: 'Withdrawn successfully',
      withdrawFailed: 'Withdraw failed',
      getApprovalRecordsFailed: 'Failed to get approval records',
      progressDialogTitle: 'Process Progress',
      noBusinessUrl: 'No business detail page available',
      // Process status mapping
      statusAll: 'All',
      statusRunning: 'Running',
      statusCompleted: 'Completed',
      statusRejected: 'Rejected',
      statusCancelled: 'Cancelled',
      statusSuspended: 'Suspended',
    },
    // Process definition
    definition: {
      title: 'Process Definition',
      processName: 'Process Name',
      processNamePlaceholder: 'Process name / key',
      businessType: 'Business Type',
      businessTypePlaceholder: 'Select business type',
      processKey: 'Process Key',
      processKeyPlaceholder: 'Enter process key (start with letter)',
      processKeyRule: 'Process key can only contain letters, numbers, underscores and hyphens, must start with a letter',
      processVersion: 'Version',
      deployStatus: 'Deploy Status',
      category: 'Category',
      categoryPlaceholder: 'Enter category',
      processDescription: 'Description',
      processDescriptionPlaceholder: 'Enter description',
      remarkPlaceholder: 'Enter remark',
      // Status
      enabled: 'Enabled',
      notEnabled: 'Not Enabled',
      deployed: 'Deployed',
      notDeployed: 'Not Deployed',
      // Actions
      design: 'Design',
      deploy: 'Deploy',
      // Dialog titles
      addTitle: 'Add Process Definition',
      editTitle: 'Edit Process Definition',
      designerTitle: 'Process Designer',
      saveProcess: 'Save Process',
      // Confirm messages
      deleteConfirm: 'Are you sure to delete this process definition?',
      deleteConfirmTitle: 'Delete Confirmation',
      deployConfirm: 'Are you sure to deploy this process definition? The process structure cannot be modified after deployment.',
      deployConfirmTitle: 'Deploy Confirmation',
      undeploy: 'Undeploy',
      undeployConfirm: 'Are you sure to undeploy this process definition? It will become a draft and you can modify the process structure.',
      undeployConfirmTitle: 'Undeploy Confirmation',
      statusChangeConfirmTitle: 'Status Change Confirmation',
      statusChangeConfirm: 'Are you sure to {action} this process definition?',
      // Success/failure messages
      updateSuccess: 'Updated successfully',
      createSuccess: 'Created successfully',
      deleteSuccess: 'Deleted successfully',
      deploySuccess: 'Deployed successfully',
      undeploySuccess: 'Undeployed successfully',
      processSaveSuccess: 'Process saved successfully',
      saveFailed: 'Save failed',
      deleteFailed: 'Delete failed',
      deployFailed: 'Deploy failed',
      undeployFailed: 'Undeploy failed',
      getDetailFailed: 'Failed to get process definition details',
      enableSuccess: 'Enabled successfully',
      disableSuccess: 'Disabled successfully',
      enableFailed: 'Enable failed',
      disableFailed: 'Disable failed',
      // Business types (now driven by wf_business_type dict table, kept as fallback)
      businessTypeContract: 'Contract',
      businessTypeContractNew: 'New Contract',
      businessTypeContractRenewal: 'Contract Renewal',
      businessTypeContractAmendment: 'Contract Amendment',
      businessTypeMerchant: 'Merchant',
      businessTypeOther: 'Other',
      // Inner page
      backToList: 'Back to List',
      readonlyDeployed: 'Deployed (Read-only)',
      processDesign: 'Process Design',
      notificationConfig: 'Notification Config',
      enableNotification: 'Enable Notification',
      notifyCreator: 'Notify Creator',
      notifyCreatorTip: 'Notify process initiator after approval',
      notifyPrevApprover: 'Notify Previous Approver',
      notifyPrevApproverTip: 'Notify previous approver after approval',
      notifyRoles: 'Notify Roles',
      notifyRolesPlaceholder: 'Select roles to notify',
      notifyRolesTip: 'Notify users in these roles after approval',
      commentRequired: 'Reject Requires Comment',
      commentRequiredTip: 'Mandatory comment when rejecting',
      notificationSaveSuccess: 'Notification config saved',
      notificationSaveFailed: 'Failed to save notification config',
      // Validation
      processKeyRequired: 'Please enter process key',
      processNameRequired: 'Please enter process name',
    },
  },
}
